import { TranslationKey } from "../../translations/TranslationKey";
import { CourseType } from "../Course";
import { TranslatedValue } from "../Shared/TranslatedValue";

export enum CandidateCourseStatus {
  Open = "Open",
  Passed = "Passed",
}

export const CandidateCourseStatusTranslationKey: {
  [courseStatus in CandidateCourseStatus]: TranslationKey;
} = {
  [CandidateCourseStatus.Open]: "candidateCourseStatus.open",
  [CandidateCourseStatus.Passed]: "candidateCourseStatus.passed",
};

export interface CandidateCourseViewModel {
  id: string;
  courseName: TranslatedValue;
  courseType: CourseType;
  status: CandidateCourseStatus;
  startingDateUtc: string;
  closingDateUtc?: string;
}

export function isCertificateAvailable(candidateCourse: CandidateCourseViewModel) {
  return (
    candidateCourse.status === CandidateCourseStatus.Passed &&
    (candidateCourse.courseType === CourseType.Hve || candidateCourse.courseType === CourseType.Intermediary || candidateCourse.courseType === CourseType.Mindeststandard)
  );
}
